import { render, staticRenderFns } from "./manage-chirurgie.html?vue&type=template&id=3220e76e&scoped=true&external"
import script from "./manage-chirurgie.js?vue&type=script&lang=js&external"
export * from "./manage-chirurgie.js?vue&type=script&lang=js&external"
import style0 from "./manage-chirurgie.scss?vue&type=style&index=0&id=3220e76e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3220e76e",
  null
  
)

export default component.exports